import { connect } from 'react-redux';

import { flightsCountSelector } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights/selectors';
import { getIsMobile } from 'src/store/view/selectors';
import { getIsFeatureHasAnOption } from 'src/utils/featureToggle';
import { isFlightListLoading } from 'src/routes/Checkout/CheckoutRoutes/PackageCheckout/store/flights-filters';
import { getArchivedAt } from 'checkout/store/selectors/package';

import { EXPERIMENT_NAMES } from 'src/components/Experiment';

import { FlightsList } from './FlightsList';

const mapStateToProps = (state) => {
  const { OPTIONS, NAME } = EXPERIMENT_NAMES.ACTUALIZE_ALTERNATIVES;
  const actualizeAlternativesAllowed = getIsFeatureHasAnOption(
    NAME,
    OPTIONS.ON,
  );
  return {
    flightsCount: flightsCountSelector(state),
    isLoading: isFlightListLoading(state, actualizeAlternativesAllowed),
    isMobile: getIsMobile(state),
    archivedAt: getArchivedAt(state),
  };
};

export default connect(mapStateToProps)(FlightsList);
